import React, { FC, useEffect } from 'react';

import { Icon, IconButton, IconButtonStyles, Icons, Tooltip } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { Entity } from '../../../../../api';
import { useAppDrawer } from '../../../../../components/AppDrawer/AppDrawerProvider';
import InvestigationDrawer from '../../../../../components/InvestigationDrawer/InvestigationDrawer';

const ENTITY_TYPE_TO_ICON = {
    [AD_ENTITY_TYPES.USER]: Icons.User,
    [AD_ENTITY_TYPES.SERVER]: Icons.Server
};

const EntityIdentityColumn: FC<Partial<Entity>> = ({ identifier, name, entityType, guid }) => {
    const { closeAppDrawer, displayContent } = useAppDrawer();

    useEffect(() => {
        return closeAppDrawer();
    }, []);

    const entityIcon = ENTITY_TYPE_TO_ICON[entityType ?? AD_ENTITY_TYPES.USER] ?? Icons.User;
    const onInvestigateClicked = () => {
        displayContent(
            <InvestigationDrawer guid={guid} identifier={name} adType={entityType || AD_ENTITY_TYPES.USER} />
        );
    };

    const displayIdentifier = name || identifier;

    return displayIdentifier && entityType ? (
        <div className="h-full w-full flex flex-1 items-center gap-[8px]">
            <Icon icon={entityIcon} size={20} className="flex-none text-sf-gray-400" />
            <Tooltip title={displayIdentifier} onlyOnOverflow>
                <span className="w-[248px] text-13 text-gray-800 font-sf">{displayIdentifier}</span>
            </Tooltip>
            <IconButton
                icon={Icons.Investigate}
                iconSize={20}
                className="invisible group-hover:visible"
                buttonStyle={IconButtonStyles.Secondary}
                onClick={onInvestigateClicked}
            />
        </div>
    ) : null;
};

export default EntityIdentityColumn;
